export default function ({ store, redirect }) {
  const auth = store.state.auth;

  if (helpers.isEmpty(auth)) {
    return redirect('/login');
  }

  if (!helpers.isEmpty(auth.email) && auth.setPasswordNeeded !== true && auth.setupOnboard !== true) {
      return redirect('/panel');
  }
}
